<template>
  <v-card class="mb-4">
    <v-card-text>
      <v-row dense>
        <!-- PO Number -->
        <v-col cols="12" md="3">
          <v-text-field
            v-model="searchFields.ponumber"
            label="PO Number"
            density="compact"
            hide-details
            clearable
            @blur="handleSearch"
            @keyup.enter="handleSearch"
          ></v-text-field>
        </v-col>

        <!-- Buyer ID -->
        <v-col cols="12" md="2">
          <v-text-field
            v-model="searchFields.buyerid"
            label="Buyer ID"
            density="compact"
            hide-details
            clearable
            @blur="handleSearch"
            @keyup.enter="handleSearch"
          ></v-text-field>
        </v-col>

        <!-- Buyer Name -->
        <v-col cols="12" md="2">
          <v-text-field
            v-model="searchFields.shippingname"
            label="Buyer Name"
            density="compact"
            hide-details
            clearable
            @blur="handleSearch"
            @keyup.enter="handleSearch"
          ></v-text-field>
        </v-col>

        <!-- Stores Multi-select -->
        <v-col cols="12" md="3">
          <v-select
            v-model="searchFields.stores"
            :items="storesStore.stores"
            item-title="name"
            item-value="slug"
            label="Stores"
            density="compact"
            hide-details
            multiple
            clearable
            @update:model-value="handleSearch"
          ></v-select>
        </v-col>

        <!-- Vendor Dropdown -->
        <v-col cols="12" md="2">
          <v-select
            v-model="searchFields.vendor"
            :items="vendors"
            item-text="vendor"
            item-value="vendor"
            label="Vendor"
            density="compact"
            hide-details
            clearable
            @update:model-value="handleSearch"
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { ref, computed, defineEmits, defineProps, watch } from 'vue'
import { useStoresStore } from '@/stores/storesStore'
import { useVendorsStore } from '@/stores/vendorsStore'
import debounce from 'lodash/debounce'

const props = defineProps({
  initialValues: {
    type: Array,
    default: () => []
  }
})

const storesStore = useStoresStore()

const emit = defineEmits(['search'])

const vendorsStore = useVendorsStore()

const searchFields = ref({
  ponumber: '',
  vendor: '',
  stores: [],
  buyerid: '',
  shippingname: ''
})

const activeFilters = ref(JSON.stringify(searchFields.value))

const vendors = computed(() => vendorsStore.vendors.map(({vendor}) => vendor))

const emitSearch = debounce(() => {
    if (JSON.stringify(searchFields.value) !== activeFilters.value) {
        activeFilters.value = JSON.stringify(searchFields.value)

  const filters = Object.entries(searchFields.value)
    .filter(([, value]) => {
      if (Array.isArray(value)) {
        return value.length > 0
      }
      return (value || '').trim() !== ''
    })
    .reduce((acc, [key, value]) => {
      acc[key] = Array.isArray(value) ? value.join(',') : value
      return acc
    }, {})

  emit('search', filters)
}   
}, 300)

const handleSearch = () => {
  emitSearch()
}
watch(() => props.initialValues, (newFilters) => {
  searchFields.value = {
    ...newFilters,
    stores: newFilters.stores?.length > 1 ? newFilters.stores.split(',') : []
  }
}, { deep: true, immediate: true })
</script> 